import ComponentManager from '@/Management/ComponentManager';
import ToolBarLinkViewModel from '@/Components/Links/ToolBarLinkViewModel';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import Utilities from '@/Utility/Utilities';
import { IRefreshable } from '#/DefaultViewExtensionInterfaces';

export default class RefreshLinkViewModel extends ToolBarLinkViewModel {

    protected dataSource: IRefreshable;

    public constructor(protected params: any) {
        super($.extend({
                ergName: params.showErgname ? 'REFRESH_TOOLTIP' : '',
                tooltipErgName: 'REFRESH_TOOLTIP',
                imageSource: GlobalConfiguration.inlineImages.REFRESH,
                locator: 'refresh'
            }, params));

        this.dataSource = this.paramOrDefault(this.params.dataSource, null);
    }

    /**
     * @override 
     */
    public onClick(openInNewWindow?: boolean, event?: JQuery.Event): void {
        this.dataSource.refresh();
    }
}

ComponentManager.setViewModel('RefreshLink', RefreshLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');